<template>
  <Headers> </Headers>
  <div :class="[deviceType, 'progressContainer']">
    <div v-if="!fail" :class="[deviceType, 'title']">
      <h1>{{ t("ccOnBoarding.resume.OTPheader") }}</h1>
      <p>{{ t("ccOnBoarding.resume.OTPdesc") }}</p>
    </div>

    <div v-if="!fail" :class="[deviceType, 'inner']">
      <div :class="[deviceType, 'content']">
        <div class="line">
          <div class="frame-36345">
            <div class="pop-up-components col-md-6">
              <div class="overlay" v-if="prop.otp.otpMobile.validated">
                <div class="content2">
                  <div class="svg-container">
                    <AcknowledgementSuccessSvg></AcknowledgementSuccessSvg>
                  </div>
                  <div class="description">
                    {{ t("ccOnBoarding.contactVerification.verified") }}
                  </div>
                </div>
              </div>
              <!-- <div v-if="mobileOverlay" class="process_overlay">
                <div class="text-center flex-container">
                  <div class="spinner-border" role="status">
                    <span class="sr-only">{{
                      t("ccOnBoarding.uploadDocument.loading2")
                    }}</span>
                  </div>
                </div>
              </div> -->
              <div class="main-title">
                <div class="enter-the-6-digit-co">
                  {{ t("ccOnBoarding.contactVerification.enter") }}
                </div>

                <div class="_60-86">
                  +{{ prop.resumeInfo.countryCode + hiddenMobileNo }}
                </div>
              </div>
              <div class="number-tile">
                <div class="_1023">{{ prop.otp.otpMobile.pac }}</div>
              </div>
              <div
                class="text-field-6-digits"
                @click="focusInput"
                ref="textInput"
              >
                <input
                  v-for="(n, index) in prop.otp.otpMobile.otp"
                  :key="index"
                  type="tel"
                  inputmode="numeric"
                  pattern="\d*"
                  :id="'input_' + index"
                  maxlength="1"
                  v-model="prop.otp.otpMobile.otp[index]"
                  @input="handleInput"
                  @keypress="isNumber"
                  @keydown.delete="handleDelete"
                  @keydown.enter.prevent="handleEnterKey"
                  @paste="onPaste"
                  @change="handleAutoPopulate"
                  :style="{
                    borderColor: isInvalid[index] ? '#E4E4E4' : '#CB03BC',
                    font: 'Outfit',
                  }"
                  :disabled="
                    prop.otp.otpMobile.full ||
                    maxOtp ||
                    expiredOtp ||
                    otpDown ||
                    otpTimeout
                  "
                  :autocomplete="'new-password'"
                  tabindex="-1"
                />
              </div>
              <pre
                class="help"
                style="
                  white-space: pre-wrap;
                  text-align: center;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
                v-if="
                  errorMessage &&
                  !maxOtp &&
                  !expiredOtp &&
                  !otpDown &&
                  !otpTimeout
                "
              >
 {{ t("otpWrong") }}</pre
              >
              <pre
                class="help"
                style="
                  white-space: pre-wrap;
                  text-align: center;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
                v-else-if="maxOtp && !expiredOtp && !otpDown && !otpTimeout"
              >
 {{ t("ccOnBoarding.otp.maxOTP") }}</pre
              >
              <pre
                class="help"
                style="
                  white-space: pre-wrap;
                  text-align: center;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
                v-else-if="!maxOtp && expiredOtp && !otpDown && !otpTimeout"
              >
 {{ t("ccOnBoarding.otp.expiredOtp") }}</pre
              >
              <pre
                class="help"
                style="
                  white-space: pre-wrap;
                  text-align: center;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
                v-else-if="!maxOtp && !expiredOtp && otpDown && !otpTimeout"
              >
 {{ t("ccOnBoarding.otp.otpService") }}</pre
              >
              <pre
                class="help"
                style="
                  white-space: pre-wrap;
                  text-align: center;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
                v-else-if="!maxOtp && !expiredOtp && !otpDown && otpTimeout"
              >
 {{ t("ccOnBoarding.otp.otpUnvailable") }}{{ customer }}</pre
              >
              <pre class="helpNull" v-else></pre>
              <div v-if="!prop.otp.otpMobile.validated" class="bottom-footer">
                <div class="already-have-an-acco">
                  {{ t("ccOnBoarding.contactVerification.xreceive") }}
                </div>
                <div class="text-button-small">
                  <p
                    class="text-button-default"
                    v-if="countdown == 0 || countdown == 60"
                    @click="startCountdown"
                  >
                    {{ t("ccOnBoarding.contactVerification.resend") }}
                  </p>
                </div>
                <p
                  class="resendText"
                  v-if="countdown !== 60 && countdown != 0 && countdown > 9"
                >
                  {{ t("ccOnBoarding.contactVerification.resendIn") }} 00:{{
                    countdown
                  }}
                </p>
                <p
                  class="resendText"
                  v-if="countdown !== 60 && countdown != 0 && countdown <= 9"
                >
                  {{ t("ccOnBoarding.contactVerification.resendIn") }} 00:0{{
                    countdown
                  }}
                </p>
              </div>
            </div>
            <p>{{ t("ccOnBoarding.resume.or") }}</p>
            <div class="pop-up-components col-md-6">
              <div class="overlay" v-if="prop.otp.otpEmail.validated">
                <div class="content2">
                  <div class="svg-container">
                    <AcknowledgementSuccessSvg></AcknowledgementSuccessSvg>
                  </div>
                  <div class="description">
                    {{ t("ccOnBoarding.contactVerification.verified") }}
                  </div>
                </div>
              </div>
              <!-- <div v-if="emailOverlay" class="process_overlay">
                <div class="text-center flex-container">
                  <div class="spinner-border" role="status">
                    <span class="sr-only">{{
                      t("ccOnBoarding.uploadDocument.loading2")
                    }}</span>
                  </div>
                </div>
              </div> -->
              <div class="main-title">
                <div class="enter-the-6-digit-co">
                  {{ t("ccOnBoarding.contactVerification.enter") }}
                </div>
                <div class="_60-86">{{ hiddenEmail }}</div>
              </div>
              <div class="number-tile">
                <div class="_1023">{{ prop.otp.otpEmail.pac }}</div>
              </div>
              <div
                class="text-field-6-digits"
                @click="focusInputEmail"
                ref="textInput"
              >
                <input
                  v-for="(n, index) in prop.otp.otpEmail.otp"
                  :key="index"
                  type="tel"
                  inputmode="numeric"
                  pattern="\d*"
                  :id="'inputEmail_' + index"
                  maxlength="1"
                  v-model="prop.otp.otpEmail.otp[index]"
                  @input="handleInput"
                  @keypress="isNumber"
                  @keydown.delete="handleDeleteEmail"
                  @keydown.enter.prevent="handleEnterKey"
                  @paste="onPasteEmail"
                  :style="{
                    borderColor: isInvalidEmail[index] ? '#E4E4E4' : '#CB03BC',
                    font: 'Outfit',
                  }"
                  :disabled="
                    prop.otp.otpEmail.full ||
                    maxOTPEmail ||
                    expiredEmail ||
                    otpEmailDown ||
                    emailTimeout
                  "
                  :autocomplete="'new-password'"
                  tabindex="-1"
                />
              </div>
              <pre
                class="help"
                style="
                  white-space: pre-wrap;
                  text-align: center;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
                v-if="
                  errorMessageEmail &&
                  !maxOTPEmail &&
                  !expiredEmail &&
                  !otpEmailDown &&
                  !emailTimeout
                "
              >
 {{ t("otpWrong") }}</pre
              >
              <pre
                class="help"
                style="
                  white-space: pre-wrap;
                  text-align: center;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
                v-else-if="
                  maxOTPEmail && !expiredEmail && !otpEmailDown && !emailTimeout
                "
              >
 {{ t("ccOnBoarding.otp.maxOTP") }}</pre
              >
              <pre
                class="help"
                style="
                  white-space: pre-wrap;
                  text-align: center;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
                v-else-if="
                  !maxOTPEmail && expiredEmail && !otpEmailDown && !emailTimeout
                "
              >
 {{ t("ccOnBoarding.otp.expiredOtp") }}</pre
              >
              <pre
                class="help"
                style="
                  white-space: pre-wrap;
                  text-align: center;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
                v-else-if="
                  !maxOTPEmail && !expiredEmail && otpEmailDown && !emailTimeout
                "
              >
 {{ t("ccOnBoarding.otp.otpService") }}</pre
              >
              <pre
                class="help"
                style="
                  white-space: pre-wrap;
                  text-align: center;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
                v-else-if="
                  !maxOTPEmail && !expiredEmail && !otpEmailDown && emailTimeout
                "
              >
 {{ t("ccOnBoarding.otp.otpUnvailable") }}{{ customer }}</pre
              >
              <pre class="helpNull" v-else></pre>
              <div v-if="!prop.otp.otpEmail.validated" class="bottom-footer">
                <div class="already-have-an-acco">
                  {{ t("ccOnBoarding.contactVerification.xreceive") }}
                </div>
                <div class="text-button-small">
                  <p
                    class="text-button-default"
                    v-if="countdownEmail == 0 || countdownEmail == 60"
                    @click="startCountdownEmail"
                  >
                    {{ t("ccOnBoarding.contactVerification.resend") }}
                  </p>
                </div>
                <p
                  class="resendText"
                  v-if="
                    countdownEmail !== 60 &&
                    countdownEmail != 0 &&
                    countdownEmail > 9
                  "
                >
                  {{ t("ccOnBoarding.contactVerification.resendIn") }} 00:{{
                    countdownEmail
                  }}
                </p>
                <p
                  class="resendText"
                  v-if="
                    countdownEmail !== 60 &&
                    countdownEmail != 0 &&
                    countdownEmail <= 9
                  "
                >
                  {{ t("ccOnBoarding.contactVerification.resendIn") }} 00:0{{
                    countdownEmail
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="prop.backSource === 'personalInfo'"
          :class="[deviceType, 'buttoncontainer2']"
        >
          <button
            :class="[deviceType, 'left-button2']"
            type="button"
            @click="back"
          >
            {{ t("ccOnBoarding.back") }}
          </button>
        </div>

        <!-- <PopupMessage
          name="'none'"
          :type="'none'"
          :header="'otpLimit'"
          v-if="isTNCModalOpen"
          @close-modal="closeTNCModal"
          :popup="true"
          :token="''"
        >
        </PopupMessage> -->
      </div>
    </div>

    <div v-if="fail">
      <div :class="[deviceType, 'retrieveContainer']">
        <div class="error-popup-sign">
          <AcknowledgementDeclinedSvg></AcknowledgementDeclinedSvg>
        </div>
        <div :class="[deviceType, 'fail-container']">
          <p>{{ t("ccOnBoarding.resume.maximumOTP") }}</p>
        </div>
        <div :class="[deviceType, 'buttoncontainer']">
          <button
            :class="[deviceType, 'left-button']"
            type="button"
            @click="startNewApplication()"
          >
            {{ t("ccOnBoarding.resume.buttonStart") }}
          </button>
          <button :class="[deviceType, 'right-button']" @click="jump()">
            {{ t("ccOnBoarding.resume.buttonBackLanding") }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="page3Overlay" class="overlay2">
    <div class="text-center flex-container">
      <p class="loading">
        <b>{{ t("ccOnBoarding.uploadDocument.loading") }}</b>
      </p>
      <br />
      <div class="spinner-border" role="status">
        <span class="sr-only">{{
          t("ccOnBoarding.uploadDocument.loading2")
        }}</span>
      </div>
      <br />
      <br />
      <p class="loading">
        <b>{{ t("ccOnBoarding.uploadDocument.loading2") }}</b>
      </p>
      <br />
      <br />
    </div>
  </div>
</template>

<script setup lang="ts">
import Headers from "./../components/Headers.vue";
import PogressBarStep from "./../components/ProgressBarStep.vue";
import {
  ref,
  computed,
  onBeforeMount,
  watch,
  onMounted,
  type PropType,
  reactive,
} from "vue";
import { useRouter } from "vue-router";
import CCOnboardFormService from "@/service/restfulService/CCOnboardFormService";
import Swal from "sweetalert2";
import i18n from "@/plugin/i18n";
import Constants from "@/constants/constants";
import type FormCC from "@/interface/FormCC";
import PopupMessage from "./../components/PopupMessage.vue";
import { deviceDetect } from "mobile-device-detect";
import type FormCCOtp from "@/interface/FormCCOtp";
import AcknowledgementSuccessSvg from "@/assets/icons/AcknowledgementSuccessSvg.vue";
import AcknowledgementDeclinedSvg from "@/assets/icons/AcknowledgementDeclinedSvg.vue";

const deviceType = ref("");
const customer = Constants.AEON_CUSTOMER_SERVICE;
const page3Overlay = ref(false);
const router = useRouter();

const prop = defineProps({
  resumeInfo: {
    type: Object,
    required: true,
  },
  otp: {
    type: Object as PropType<FormCCOtp>,
    required: true,
  },
  type: {
    type: String,
  },
  resumeDraftData: {
    type: Object,
    required: true,
  },
  resumeWebFormRequestId: {
    type: String,
  },
  isReminder: {
    type: Boolean,
  },
  cardId: {
    type: String,
  },
  resumeApplication: {
    type: Boolean,
    required: true,
  },
  backSource: {
    type: String,
    default: "",
  },
});

const { t } = i18n.global;
const errorMessage = ref(false);
const errorMessageEmail = ref(false);
const otpDown = ref(false);
const otpEmailDown = ref(false);
const maxOtp = ref(false);
const maxOTPEmail = ref(false);
const fail = ref(false);
const expiredOtp = ref(false);
const expiredEmail = ref(false);
const otpTimeout = ref(false);
const emailTimeout = ref(false);
const updateStatus = ref(true);
const mobileOverlay = ref(false);
const emailOverlay = ref(false);

let isTNCModalOpen = ref(false);
let dataFromPaste: string[] | undefined;
let dataFromPasteEmail: string[] | undefined;
const keysAllowed: string[] = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
];

const closeTNCModal = () => {
  isTNCModalOpen.value = false;
  fail.value = false;
  emit("jumpStep", 14, "denied2", 3);
};

onMounted(() => {
  const requestModel = {
    mobileNo: prop.resumeInfo.countryCode + prop.resumeInfo.mobileNo,
    mobileNoCountryCode: prop.resumeInfo.countryCode,
    email: prop.resumeInfo.email,
    webFormType: "cc",
    webFormRequestId: "",
    skipToken: true,
  };
  if (!prop.otp.otpMobile.success) {
    defaultCountdown();
    CCOnboardFormService.requestOTP(requestModel, "")
      .then((res) => {
        if (res.status == 200) {
          prop.otp.otpMobile.pac = res.data.responseModel.otp.otpPacNo;
        }
      })
      .catch((e) => {
        otpTimeout.value = true;
      });
  }

  if (!prop.otp.otpEmail.success) {
    defaultCountdownEmail();
    CCOnboardFormService.requestEmailOTP(requestModel, "")
      .then((res) => {
        if (res.status == 200) {
          prop.otp.otpEmail.pac = res.data.responseModel.otp.otpPacNo;
        }
      })
      .catch((e) => {
        emailTimeout.value = true;
      });
  }

  const { isMobile, isTablet } = deviceDetect();

  if (isMobile) {
    deviceType.value = "Mobile";
  } else if (isTablet) {
    deviceType.value = "Tablet";
  } else {
    deviceType.value = "Desktop";
  }
});

const countdown = ref(60);
let countdownTimer: number | null = null;
const countdownEmail = ref(60);
let countdownTimerEmail: number | null = null;

// const countdownReciprocal = computed(() => {
//   return countdown.value > 0 ? (1 / countdown.value).toFixed(2) : 0;
// });

// function getReciprocal() {
//   return countdownReciprocal.value;
// }

function defaultCountdown() {
  if (countdownTimer !== null) {
    clearInterval(countdownTimer);
  }

  prop.otp.otpMobile.number = 0;
  prop.otp.otpMobile.otp = Array(6).fill("");
  prop.otp.otpMobile.needValidate = true;
  prop.otp.otpMobile.full = false;
  maxOtp.value = false;

  countdown.value = 60 - 1; // Reset countdown to 60 seconds

  countdownTimer = setInterval(() => {
    if (countdown.value > 0) {
      countdown.value--;
    } else {
      clearInterval(countdownTimer as number);
      countdownTimer = null;
    }
  }, 1000);
}

function startCountdown() {
  if (countdownTimer !== null) {
    clearInterval(countdownTimer);
  }

  prop.otp.otpMobile.number = 0;
  prop.otp.otpMobile.otp = Array(6).fill("");
  prop.otp.otpMobile.needValidate = true;
  prop.otp.otpMobile.full = false;
  errorMessage.value = false;
  maxOtp.value = false;
  otpTimeout.value = false;
  otpDown.value = false;
  const requestModel = {
    mobileNo: prop.resumeInfo.countryCode + prop.resumeInfo.mobileNo,
    mobileNoCountryCode: prop.resumeInfo.countryCode,
    webFormType: "cc",
    webFormRequestId: "",
    skipToken: true,
  };

  CCOnboardFormService.resendOTP(requestModel, "")
    .then((res) => {
      if (res.status == 200) {
        prop.otp.otpMobile.pac = res.data.responseModel.otp.otpPacNo;
        prop.otp.otpMobile.resend = prop.otp.otpMobile.resend + 1;
        prop.otp.otpMobile.success = false;
        otpDown.value = false;
        maxOtp.value = false;
        expiredOtp.value = false;
        otpTimeout.value = false;
      }
    })
    .catch((e) => {
      otpTimeout.value = true;
    });

  countdown.value = 60 - 1; // Reset countdown to 60 seconds

  countdownTimer = setInterval(() => {
    if (countdown.value > 0) {
      countdown.value--;
    } else {
      clearInterval(countdownTimer as number);
      countdownTimer = null;
    }
  }, 1000);
}

function defaultCountdownEmail() {
  if (countdownTimerEmail !== null) {
    clearInterval(countdownTimerEmail);
  }
  prop.otp.otpEmail.number = 0;
  maxOTPEmail.value = false;
  prop.otp.otpEmail.otp = Array(6).fill("");
  prop.otp.otpEmail.needValidate = true;
  prop.otp.otpEmail.full = false;

  countdownEmail.value = 60 - 1; // Reset countdown to 60 seconds

  countdownTimerEmail = setInterval(() => {
    if (countdownEmail.value > 0) {
      countdownEmail.value--;
    } else {
      clearInterval(countdownTimerEmail as number);
      countdownTimerEmail = null;
    }
  }, 1000);
}

function startCountdownEmail() {
  if (countdownTimerEmail !== null) {
    clearInterval(countdownTimerEmail);
  }
  prop.otp.otpEmail.number = 0;
  errorMessageEmail.value = false;
  maxOTPEmail.value = false;
  prop.otp.otpEmail.otp = Array(6).fill("");
  prop.otp.otpEmail.needValidate = true;
  prop.otp.otpEmail.full = false;
  emailTimeout.value = false;
  otpEmailDown.value = false;
  const requestModel = {
    email: prop.resumeInfo.email,
    webFormType: "cc",
    webFormRequestId: "",
    skipToken: true,
  };

  CCOnboardFormService.resendEmailOTP(requestModel, "")
    .then((res) => {
      if (res.status == 200) {
        prop.otp.otpEmail.pac = res.data.responseModel.otp.otpPacNo;
        const resp = res.data;
        prop.otp.otpEmail.resend = prop.otp.otpEmail.resend + 1;
        prop.otp.otpEmail.success = false;
        otpEmailDown.value = false;
        maxOTPEmail.value = false;
        expiredEmail.value = false;
        emailTimeout.value = false;
      }
    })
    .catch((e) => {
      emailTimeout.value = true;
    });

  countdownEmail.value = 60 - 1; // Reset countdown to 60 seconds

  countdownTimerEmail = setInterval(() => {
    if (countdownEmail.value > 0) {
      countdownEmail.value--;
    } else {
      clearInterval(countdownTimerEmail as number);
      countdownTimerEmail = null;
    }
  }, 1000);
}

const hiddenMobileNo = computed(() => {
  if (prop.resumeInfo.mobileNo.length < 6) {
    return prop.resumeInfo.mobileNo;
  }

  const visibleLength = 0;
  const hiddenLength = prop.resumeInfo.mobileNo.length - 2;
  const hiddenChars = "*".repeat(hiddenLength);

  return (
    prop.resumeInfo.mobileNo.slice(0, visibleLength) +
    hiddenChars +
    prop.resumeInfo.mobileNo.slice(-2)
  );
});

const hiddenEmail = computed(() => {
  const atIndex = prop.resumeInfo.email.indexOf("@");
  if (atIndex == 1) {
    return prop.resumeInfo.email;
  }
  let visibleLength;
  if (atIndex > 1 && atIndex < 5) {
    visibleLength = 1;
  } else {
    visibleLength = 3;
  }
  const hiddenLength = 3;
  const hiddenChars = "*".repeat(hiddenLength);

  return (
    prop.resumeInfo.email.slice(0, visibleLength) +
    hiddenChars +
    prop.resumeInfo.email.slice(atIndex)
  );
});

function isNumber(event: Event) {
  (event.currentTarget as HTMLInputElement).value = "";
  const keyPressed: string = (event as KeyboardEvent).key;
  if (!keysAllowed.includes(keyPressed)) {
    event.preventDefault();
  }
}
const test = ref("");
// const codeIndexLength = computed(() => code.value.join(""));
function focusInput() {
  const codeIndexLength = computed(() => prop.otp.otpMobile.otp.join(""));
  if (codeIndexLength.value.length != 0) {
    const inputElement = document.getElementById(
      "input_" + codeIndexLength.value.length,
    );

    if (inputElement) {
      inputElement.focus();
    }
  } else if (codeIndexLength.value.length == 0) {
    const inputElement = document.getElementById("input_" + 0);
    if (inputElement) {
      inputElement.focus();
    }
  }
}

function focusInputEmail() {
  const codeIndexLength = computed(() => prop.otp.otpEmail.otp.join(""));
  if (codeIndexLength.value.length != 0) {
    const inputElement = document.getElementById(
      "inputEmail_" + codeIndexLength.value.length,
    );
    if (inputElement) {
      inputElement.focus();
    }
  } else if (codeIndexLength.value.length == 0) {
    const inputElement = document.getElementById("inputEmail_" + 0);
    if (inputElement) {
      inputElement.focus();
    }
  }
}

function handleInput(event: Event) {
  // errorMessage.value = false;
  // errorMessageEmail.value = false;
  const inputType = (event as InputEvent).inputType;
  let currentActiveElement = event.target as HTMLInputElement;
  const currentInputId = currentActiveElement.id;

  function getWordsBeforeUnderscore(id: string): string | null {
    const parts = id.split("_");
    if (parts.length > 1) {
      return parts[0];
    } else {
      return null;
    }
  }

  const wordsBeforeUnderscore = getWordsBeforeUnderscore(currentInputId);
  if (inputType === "insertText")
    (currentActiveElement.nextElementSibling as HTMLElement)?.focus();

  if (
    inputType === "insertFromPaste" &&
    dataFromPasteEmail &&
    wordsBeforeUnderscore == "inputEmail"
  ) {
    for (const num of dataFromPasteEmail) {
      let id: number = parseInt(currentActiveElement.id.split("_")[1]);
      currentActiveElement.value = num;
      prop.otp.otpEmail.otp[id] = num;
      if (currentActiveElement.nextElementSibling) {
        currentActiveElement =
          currentActiveElement.nextElementSibling as HTMLInputElement;
        (currentActiveElement.nextElementSibling as HTMLElement)?.focus();
      }
    }
  }
  if (
    inputType === "insertFromPaste" &&
    dataFromPaste &&
    wordsBeforeUnderscore == "input"
  ) {
    for (const num of dataFromPaste) {
      let id: number = parseInt(currentActiveElement.id.split("_")[1]);
      currentActiveElement.value = num;
      prop.otp.otpMobile.otp[id] = num;
      if (currentActiveElement.nextElementSibling) {
        currentActiveElement =
          currentActiveElement.nextElementSibling as HTMLInputElement;
        (currentActiveElement.nextElementSibling as HTMLElement)?.focus();
      }
    }
  }
  const isCodeArrayFull = prop.otp.otpMobile.otp.every(
    (element) => element !== undefined && element !== null && element !== "",
  );
  const isCodeArrayFullEmail = prop.otp.otpEmail.otp.every(
    (element) => element !== undefined && element !== null && element !== "",
  );
  if (isCodeArrayFull) {
    prop.otp.otpMobile.full = true;
  } else if (isCodeArrayFullEmail) {
    prop.otp.otpEmail.full = true;
  }
  // Validation
  if (isCodeArrayFull || isCodeArrayFullEmail) {
    if (
      isCodeArrayFull &&
      prop.otp.otpMobile.needValidate &&
      prop.otp.otpMobile.number < 3
    ) {
      if (prop.otp.otpMobile.resend <= 51) {
        phoneOTP();
      }
    } else if (
      isCodeArrayFullEmail &&
      prop.otp.otpEmail.needValidate &&
      prop.otp.otpEmail.number < 3
    ) {
      if (prop.otp.otpEmail.resend <= 51) {
        emailOTP();
      }
    }
  }
}

const handleAutoPopulate = (event: Event) => {
  const value = (event.target as HTMLInputElement).value;
  const index = parseInt((event.target as HTMLInputElement).id.split("_")[1]);
  if (value.length === 1 && index < prop.otp.otpMobile.otp.length - 1) {
    const nextInput = document.getElementById(`input_${index + 1}`);
    if (nextInput) {
      nextInput.focus();
    }
  }
};

watch(
  [() => prop.otp.otpMobile.resend, () => prop.otp.otpMobile.number],
  ([resend, number], [prevResend, prevNumber]) => {
    if (resend == 50) {
      if (number >= 3) {
        fail.value = true;
      }
    } else if (resend == 51) {
      fail.value = true;
    }
  },
);

watch(
  [() => prop.otp.otpEmail.resend, () => prop.otp.otpEmail.number],
  ([resend, number], [prevResend, prevNumber]) => {
    if (resend == 50) {
      if (number >= 3) {
        fail.value = true;
      }
    } else if (resend == 51) {
      fail.value = true;
    }
  },
);

watch(
  () => fail.value,
  (newValue) => {
    if (newValue == true) {
      isTNCModalOpen.value = true;
    }
  },
);

// watch(
//   [() => prop.otp.otpMobile.validated, () => prop.otp.otpEmail.validated],
//   ([newValue1, newValue2], [oldValue1, oldValue2]) => {
//     if (newValue1 === true && newValue2 === true) {
//       checkOtpResult();
//     }
//   }
// );

// watch([() => prop.otp.otpMobile.validated], ([newValue1]) => {
//   if (newValue1 === true) {
//     checkMobileOtpResult();
//   }
// });

// watch([() => prop.otp.otpEmail.validated], ([newValue1]) => {
//   if (newValue1 === true) {
//     checkEmailOtpResult();
//   }
// });

watch(
  [() => prop.otp.otpMobile.validated, () => prop.otp.otpEmail.validated],
  ([newValue1, newValue2], [oldValue1, oldValue2]) => {
    if (newValue1 === true || newValue2 === true) {
      prop.otp.verified = "true";
      // if (
      //   prop.contactInformation.basicInformation.idType == "0" &&
      //   prop.contactInformation.ekyc.status == "COMPLETE"
      // ) {
      //   prop.otp.principalStatus = "";
      //   prop.otp.otpEmail.status = "";
      //   prop.otp.otpMobile.status = "";
      //   emit("submit");
      // } else {
      prop.otp.principalStatus = "";
      prop.otp.otpEmail.status = "";
      prop.otp.otpMobile.status = "";
      if (prop.isReminder) {
        router.push({
          name: "CCProgressRoutePage",
          state: {
            draftListing: true,
            comeFromReminderLink: true,
          },
          query: {
            webFormRequestId: prop.resumeWebFormRequestId
              ? prop.resumeWebFormRequestId
              : prop.resumeDraftData[0].webFormRequestId,
          },
        });
      } else if (prop.resumeInfo.isResumedByStaff) {
        // resumed by staff
        router.push({
          name: "CCProgressRoutePage",
          state: {
            draftListing: true,
            resumedByRecruiterId: prop.resumeInfo.recruiterId,
            resumedByRecruiterName: prop.resumeInfo.recruiterName,
          },
          query: {
            webFormRequestId: prop.resumeInfo.webFormRequestId,
          },
        });
      } else if (prop.resumeDraftData.length == 1) {
        // 1 record only or reminder link
        router.push({
          name: "CCProgressRoutePage",
          state: {
            draftListing: true,
          },
          query: {
            webFormRequestId: prop.resumeWebFormRequestId
              ? prop.resumeWebFormRequestId
              : prop.resumeDraftData[0].webFormRequestId,
          },
        });
      } else emit("jumpStep", 105, "", 3);
      // }
    }
  },
);

function handleDelete(event: Event) {
  const codeIndexLength = computed(() => prop.otp.otpMobile.otp.join(""));
  const inputElement = document.getElementById(
    "input_" + codeIndexLength.value.length,
  );

  let value = (event.target as HTMLInputElement).value;
  let currentActiveElement = inputElement as HTMLInputElement;

  if (!value) {
    const previousElement =
      currentActiveElement.previousElementSibling as HTMLInputElement;
    if (previousElement) {
      previousElement.focus();

      prop.otp.otpMobile.otp[codeIndexLength.value.length - 1] = "";
    }
  }
}

function handleDeleteEmail(event: Event) {
  const codeIndexLength = computed(() => prop.otp.otpEmail.otp.join(""));
  const inputElement = document.getElementById(
    "inputEmail_" + codeIndexLength.value.length,
  );

  let value = (event.target as HTMLInputElement).value;
  let currentActiveElement = inputElement as HTMLInputElement;

  if (!value) {
    const previousElement =
      currentActiveElement.previousElementSibling as HTMLInputElement;
    if (previousElement) {
      previousElement.focus();

      prop.otp.otpEmail.otp[codeIndexLength.value.length - 1] = "";
    }
  }
}

const handleEnterKey = () => {};

function onPaste(event: Event) {
  dataFromPaste = (event as ClipboardEvent).clipboardData
    ?.getData("text")
    .trim()
    .split("");

  if (dataFromPaste) {
    for (const num of dataFromPaste) {
      if (!keysAllowed.includes(num)) event.preventDefault();
    }
  }
}

function onPasteEmail(event: Event) {
  dataFromPasteEmail = (event as ClipboardEvent).clipboardData
    ?.getData("text")
    .trim()
    .split("");

  if (dataFromPasteEmail) {
    for (const num of dataFromPasteEmail) {
      if (!keysAllowed.includes(num)) event.preventDefault();
    }
  }
}

const isInvalid = computed(() => {
  return prop.otp.otpMobile.otp.map((input) => input.length === 0);
});

const otpValue = computed(() => prop.otp.otpMobile.otp.join(""));

const isInvalidEmail = computed(() => {
  return prop.otp.otpEmail.otp.map((input) => input.length === 0);
});

const otpValueEmail = computed(() => prop.otp.otpEmail.otp.join(""));

const phoneOTP = () => {
  mobileOverlay.value = true;
  const requestModel = {
    mobileNo: prop.resumeInfo.countryCode + prop.resumeInfo.mobileNo,
    mobileNoCountryCode: prop.resumeInfo.countryCode,
    otp: {
      otpValue: otpValue.value,
      otpPacNo: prop.otp.otpMobile.pac,
    },
  };

  CCOnboardFormService.validateOTP(requestModel)
    .then((res) => {
      mobileOverlay.value = false;
      if (res.status == 200) {
        errorMessage.value = false;
        prop.otp.otpMobile.validated = true;
        prop.otp.otpMobile.needValidate = false;
        prop.otp.otpMobile.success = true;
      }
    })
    .catch((e) => {
      mobileOverlay.value = false;
      if (e.response.data.message == "4022") {
        expiredOtp.value = true;
      } else if (e.response.data.message == "4021") {
        errorMessage.value = true;
      } else {
        otpDown.value = true;
      }
      prop.otp.otpMobile.number = prop.otp.otpMobile.number + 1;
      if (prop.otp.otpMobile.number >= 3 && expiredOtp.value != true) {
        maxOtp.value = true;
      }
      prop.otp.otpMobile.otp = Array(6).fill("");
      prop.otp.otpMobile.full = false;
      prop.otp.otpMobile.validated = false;
      prop.otp.otpMobile.success = false;
      for (let index = 0; index < 6; index++) {
        const inputElement = document.getElementById(
          "input_" + index,
        ) as HTMLInputElement;
        if (inputElement) {
          inputElement.value = "";
        }
      }
      const inputElement = document.getElementById("input_" + 0);
      if (inputElement) {
        inputElement.focus();
      }
    });
};

const emailOTP = () => {
  emailOverlay.value = true;
  const requestModel = {
    email: prop.resumeInfo.email,
    otp: {
      otpValue: otpValueEmail.value,
      otpPacNo: prop.otp.otpEmail.pac,
    },
  };

  CCOnboardFormService.validateEmailOTP(requestModel)
    .then((res) => {
      emailOverlay.value = false;
      if (res.status == 200) {
        errorMessageEmail.value = false;
        prop.otp.otpEmail.validated = true;
        prop.otp.otpEmail.needValidate = false;
        prop.otp.otpEmail.success = true;
      }
    })
    .catch((e) => {
      emailOverlay.value = false;
      if (e.response.data.message == "4022") {
        expiredEmail.value = true;
      } else if (e.response.data.message == "4021") {
        errorMessageEmail.value = true;
      } else {
        otpEmailDown.value = true;
      }
      prop.otp.otpEmail.validated = false;
      prop.otp.otpEmail.success = false;
      for (let index = 0; index < 6; index++) {
        const inputElementEmail = document.getElementById(
          "inputEmail_" + index,
        ) as HTMLInputElement;
        if (inputElementEmail) {
          inputElementEmail.value = "";
        }
      }
      const inputElementEmail = document.getElementById("inputEmail_" + 0);
      if (inputElementEmail) {
        inputElementEmail.focus();
      }
      prop.otp.otpEmail.otp = Array(6).fill("");
      prop.otp.otpEmail.full = false;
      prop.otp.otpEmail.number = prop.otp.otpEmail.number + 1;
      if (prop.otp.otpEmail.number >= 3 && expiredEmail.value != true) {
        maxOTPEmail.value = true;
      }
    });
};

const emit = defineEmits([
  "nextStep",
  "previousStep",
  "submit",
  "jumpStep",
  "newApplication",
]);

// const checkOtpResult = () => {
//   const requestModel = {
//     webFormRequestId: prop.contactInformation.webFormRequestId,
//     type: "CC_P",
//   };
//   CCOnboardFormService.updateStatus(requestModel).then((res) => {
//     if (res.status == 200) {
//       //Test
//       // emit("submit");
//       if (
//         prop.contactInformation.basicInformation.idType == "0" &&
//         prop.contactInformation.ekyc.status == "COMPLETE"
//       ) {
//         prop.otp.principalStatus = "";
//         prop.otp.otpEmail.status = "";
//         prop.otp.otpMobile.status = "";
//         emit("submit");
//       } else {
//         prop.otp.principalStatus = "";
//         prop.otp.otpEmail.status = "";
//         prop.otp.otpMobile.status = "";
//         emit("jumpStep", 4, "", 3);
//       }
//     }
//   });
// };

// const checkMobileOtpResult = () => {
//   updateStatus.value = true;
//   const requestModel = {
//     webFormRequestId: "",
//     type: "CC_P",
//     otpType: "mobileOtp",
//   };
//   CCOnboardFormService.updateStatus(requestModel).then((res) => {
//     if (res.status == 200) {
//       if (prop.otp.otpEmail.validated) {
//         updateStatus.value = false;
//       }
//       //Test
//       // emit("submit");
//       // if (
//       //   prop.contactInformation.basicInformation.idType == "0" &&
//       //   prop.contactInformation.ekyc.status == "COMPLETE"
//       // ) {
//       //   prop.otp.principalStatus = "";
//       //   prop.otp.otpEmail.status = "";
//       //   prop.otp.otpMobile.status = "";
//       // } else {
//       prop.otp.principalStatus = "";
//       prop.otp.otpEmail.status = "";
//       prop.otp.otpMobile.status = "";
//       // }
//     }
//   });
// };

// const checkEmailOtpResult = () => {
//   updateStatus.value = true;
//   const requestModel = {
//     webFormRequestId: "",
//     type: "CC_P",
//     otpType: "emailOtp",
//   };
//   CCOnboardFormService.updateStatus(requestModel).then((res) => {
//     if (res.status == 200) {
//       if (prop.otp.otpMobile.validated) {
//         updateStatus.value = false;
//       }

//       //Test
//       // emit("submit");
//       // if (
//       //   prop.contactInformation.basicInformation.idType == "0" &&
//       //   prop.contactInformation.ekyc.status == "COMPLETE"
//       // ) {
//       //   prop.otp.principalStatus = "";
//       //   prop.otp.otpEmail.status = "";
//       //   prop.otp.otpMobile.status = "";
//       // } else {
//       prop.otp.principalStatus = "";
//       prop.otp.otpEmail.status = "";
//       prop.otp.otpMobile.status = "";
//       // }
//     }
//   });
// };

const next = () => {
  emit("nextStep");
};
const notEditable = ref("");

const jump = () => {
  if (prop.type == "BIO") emit("jumpStep", 16, "", 3);
  else emit("jumpStep", 101, "", 3);
};

const startNewApplication = () => {
  emit("newApplication");
  if ((prop.cardId == "NA" || prop.cardId == "") && prop.type !== "BIO") {
    emit("jumpStep", 0, "", 4);
  } else emit("jumpStep", 1, "", 4);
};

const back = () => {
  // if (prop.otp.otpMobile.success && !prop.otp.otpEmail.success) {
  //   prop.otp.otpEmail.status = "falseEmail";
  //   // notEditable.value = "falseEmail";
  // }
  // if (!prop.otp.otpMobile.success && prop.otp.otpEmail.success) {
  //   prop.otp.otpMobile.status = "falseOtp";
  //   // notEditable.value = "falseOtp";
  // }
  // if (!prop.otp.otpMobile.success && !prop.otp.otpEmail.success) {
  //   prop.otp.principalStatus = "falseBoth";
  // }

  if (prop.resumeApplication == true) {
    emit("jumpStep", 102, "resume", 3);
  } else {
    emit("jumpStep", 102, "start", 3);
  }
};
</script>

<style scoped>
.progressContainer {
  max-width: 1440px;
  margin: auto;
  padding: 4% 8%;
  background: #fff;
}

.frame-36279 {
  margin: 0 112px;
  padding: 0px 104px;
  display: flex;
  flex-direction: column;
  /* gap: 32px; */
  /* align-items: center; */
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}
.frame-36345 {
  text-align: center;
  border-radius: 16px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 32px;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
  margin-bottom: 32px;
}

.pop-up-components {
  background: #f7fbff;
  border-radius: 10px;
  border-style: solid;
  border-color: #f1f1f1;
  border-width: 4px;
  padding: 24px 16px 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: center;
  flex: 1;
  position: relative;
  height: 350px;
}

.main-title {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}

.enter-the-6-digit-co {
  color: var(--black-medium-54, rgba(0, 0, 0, 0.54));
  text-align: center;
  font: var(--subtitle-1-medium, 500 16px/130% "Outfit", sans-serif);
  position: relative;
  align-self: stretch;
}

._60-86 {
  color: var(--black-high-87, rgba(0, 0, 0, 0.87));
  text-align: center;
  font: var(--body-regular, 400 16px/130% "Outfit", sans-serif);
  position: relative;
  align-self: stretch;
}

.number-tile {
  background: #f6f7f8;
  border-radius: 6px;
  border-style: solid;
  border-color: #e4e4e4;
  border-width: 1px;
  padding: 8px 12px 8px 12px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 60px;
  position: relative;
}

._1023 {
  color: var(--black-medium-54, rgba(0, 0, 0, 0.54));
  text-align: center;
  font: var(--subtitle-2, 500 14px/130% "Outfit", sans-serif);
  position: relative;
}

.text-field-6-digits {
  flex-shrink: 0;
  width: 100%;
  /* position: relative; */
  overflow: hidden;
  margin-left: 15px;
  text-align: center;
}

.bottom-footer {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}

.already-have-an-acco {
  color: var(--black-medium-54, rgba(0, 0, 0, 0.54));
  text-align: center;
  font: var(--subtitle-2, 500 14px/130% "Outfit", sans-serif);
  position: relative;
}

.resendText {
  color: var(--black-low-38, rgba(0, 0, 0, 0.38));
  text-align: center;
  font: var(--subtitle-2, 500 14px/130% "Outfit", sans-serif);
  position: relative;
  margin-bottom: 0;
}

.text-button-small {
  display: flex;
  flex-direction: row;
  margin-left: 6px;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}

.text-button-default {
  color: var(--primary-active, #ac2887);
  text-align: left;
  font: var(--subtitle-2, 500 14px/130% "Outfit", sans-serif);
  position: relative;
  margin-bottom: 0;
  cursor: pointer;
}

input[type="tel"] {
  width: 8%;
  height: 50px;
  opacity: 1;
  text-align: center;
  margin-right: 5.5%;
  outline: 0;
  border-width: 0 0 3px;
  border-color: #cb03bc;
  color: rgba(0, 0, 0, 0.87);
  font: 400 30px/130% "Outfit";
  text-rendering: auto;
  top: calc(50% - 20px);
  padding: 0;
  box-sizing: border-box;
  background-color: transparent;
}

.help {
  color: red;
  font:
    400 14px/130% "Outfit",
    sans-serif;
  margin-bottom: 0;
}

.helpNull {
  margin-bottom: 18px;
}

.content {
  margin-top: 40px;
  padding: 0 8%;
}

.content2 {
  display: flex;
  flex-direction: column;
  align-items: center;
}

input:focus {
  outline: none;
}

input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px #f7fbff inset;
}

.loading {
  margin-bottom: 0;
  font-family: "Outfit";
  color: white;
}

.spinner-border {
  width: 5rem;
  height: 5rem;
  color: white;
}

.flex-container {
  left: 0;
  margin: auto;
  position: absolute;
  text-align: center;
  top: 35%;
  right: 30%;
  left: 30%;
}

.fail-container {
  margin: auto;
  text-align: center;
  width: 70%;
}

.fail-container p {
  color: var(--Primary-Active, #ac2887);
  text-align: center;

  /* H2 */
  font-family: Outfit;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 26px */
}

.description {
  color: #212121;
  font: 500 22px/130% "Outfit";
  margin-bottom: 2px;
  text-align: left;
  position: relative;
}

.svg-container {
  margin-bottom: 10px; /* Adjust this value as needed */
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.9);
  z-index: 999;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: fadeIn 0.5s ease forwards;
  opacity: 0;
}

.overlay2 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 110%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  will-change: transform, opacity;
  transform: translateZ(0);
  overflow-y: hidden;
  transition: top 0.3s;
}

.process_overlay {
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 999;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: fadeIn 0.5s ease forwards;
  opacity: 0;
  border-radius: 10px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media (max-width: 955px) {
  /* .frame-36279 {
    margin: 0;
    padding: 0 50px;
  } */
}
@media (max-width: 870px) {
  .frame-36345 {
    display: block;
  }

  .frame-36345 .pop-up-components {
    margin-bottom: 16px;
  }

  .col-md-6 {
    width: 100%;
  }
}

@media (max-width: 700px) {
  .buttoncontainer:is(.Desktop, .Tablet),
  .buttoncontainer2:is(.Desktop, .Tablet) {
    gap: 10px;
  }

  .left-button:is(.Desktop, .Tablet),
  .left-button2:is(.Desktop, .Tablet) {
    flex: 0 0 30%;
  }

  .right-button:is(.Desktop, .Tablet) {
    flex: 0 0 68%;
  }
}

.frame-36279:is(.Mobile) {
  padding: 0;
}

.buttoncontainer {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  width: 100%;
  max-width: 500px;
  margin: 40px auto;
}

.buttoncontainer:is(.Mobile) {
  flex-flow: column;
  margin: 0;
}

.buttoncontainer2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
  margin-bottom: 24px;
}

.left-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: 1px solid #cb03bc;
  background-color: white;
  font-size: 14px;
  font-weight: 500;
  color: #cb03bc;
}

.left-button2 {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: 1px solid #cb03bc;
  background-color: white;
  font-size: 14px;
  font-weight: 500;
  color: #cb03bc;
  flex: 0 0 25%;
}

.right-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background-image: var(
    --gradient-set-active,
    linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
  );
  font-size: 14px;
  font-weight: 600;
  color: #fff;
}

.right-button:is(.Mobile) {
  flex: 0 0 68%;
}

.progressContainer:is(.Mobile) {
  max-width: 1440px;
  margin: auto;
  padding: 0;
  background: #fff;
}

.inner:is(.Mobile) {
  padding: 20px 20px 0 20px;
}

.left-button:is(.Mobile),
.left-button2:is(.Mobile) {
  flex: 0 0 30%;
}

.title:is(.Mobile) {
  padding: 20px 16px 0 16px;
}

h1 {
  color: var(--Web-Black-High, #212121);

  /* Custom 3 */
  font-family: Outfit;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 31.2px */
}

p {
  color: var(--Web-Black-Medium, #757575);

  /* Body (Regular) */
  font-family: Outfit;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */
}

.error-popup-sign,
.error-popup-sign * {
  box-sizing: border-box;
}

.error-popup-sign {
  background: var(--alert-negative, #df0029);
  border-radius: 60px;
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  position: relative;
  margin: 0px auto 30px auto;
}

.group-208 {
  height: auto;
  position: absolute;
  left: calc(50% - 11px);
  top: calc(50% - 12px);
  overflow: visible;
}

.retrieveContainer:is(.Mobile) {
  margin-top: 30px;
}

.fail-container:is(.Mobile) {
  width: 100%;
  padding: 0 20px;
}
</style>
